export const warn = (msg: string) => {
  if (typeof jest !== "undefined") {
    return; // don't throw warnings when running tests
  }
  if (console && typeof console.warn === "function") {
    console.warn(msg);
  }
};

export const errWithInfo = (appId: number, type: string, msg: string) => {
  throw new Error(`action ${type} failed on loan app ${appId}: ${msg}`);
};

export const assertVal = (appId: number, type: string, name: string, val: string | number) => {
  if (val === null) {
    errWithInfo(appId, type, `${name} is null`);
  } else if (val === "") {
    errWithInfo(appId, type, `${name} is empty`);
  } else if (val === 0) {
    errWithInfo(appId, type, `${name} is 0`);
  }
};
